/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */

import React, { useState } from 'react';
import { Tabs } from 'antd';
import { UserOutlined, IdcardOutlined, BookOutlined } from '@ant-design/icons';
import EmployeesTab from './tabs/EmployeesTab';
import CardsTab from './tabs/CardsTab';
import TrainingsTab from './tabs/TrainingsTab';

const CompanyTabs = ({
  employeesData,
  cardsData,
  trainingsData,
  employeesLoading,
  cardsLoading,
  trainingsLoading,
  employeesError,
  cardsError,
  trainingsError,
  dateRange,
  onDateRangeChange,
  startDate,
  endDate
}) => {
  const [activeTab, setActiveTab] = useState('employees');

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const items = [
    {
      key: 'employees',
      label: (
        <span className="flex items-center px-4 py-2 transition-all duration-300 transform hover:scale-105">
          <UserOutlined className="mr-2 text-lg" />
          <span className="font-semibold">Employees</span>
        </span>
      ),
      children: (
        <div className="p-6 bg-white rounded-lg shadow-2xl border border-gray-200 transform transition-all duration-500 hover:scale-[1.02]">
          <EmployeesTab
            data={employeesData}
            loading={employeesLoading}
            error={employeesError}
            dateRange={dateRange}
            onDateRangeChange={onDateRangeChange}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      ),
    },
    {
      key: 'cards',
      label: (
        <span className="flex items-center px-4 py-2 transition-all duration-300 transform hover:scale-105">
          <IdcardOutlined className="mr-2 text-lg" />
          <span className="font-semibold">Cards</span>
        </span>
      ),
      children: (
        <div className="p-6 bg-white rounded-lg shadow-2xl border border-gray-200 transform transition-all duration-500 hover:scale-[1.02]">
          <CardsTab
            data={cardsData}
            loading={cardsLoading}
            error={cardsError}
            dateRange={dateRange}
            onDateRangeChange={onDateRangeChange}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      ),
    },
    {
      key: 'trainings',
      label: (
        <span className="flex items-center px-4 py-2 transition-all duration-300 transform hover:scale-105">
          <BookOutlined className="mr-2 text-lg" />
          <span className="font-semibold">Trainings</span>
        </span>
      ),
      children: (
        <div className="p-6 bg-white rounded-lg shadow-2xl border border-gray-200 transform transition-all duration-500 hover:scale-[1.02]">
          <TrainingsTab
            data={trainingsData}
            loading={trainingsLoading}
            error={trainingsError}
            dateRange={dateRange}
            onDateRangeChange={onDateRangeChange}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="mt-8">
      <style jsx>{`
        .company-tabs .ant-tabs-tab {
          background: linear-gradient(145deg, #f8fafc, #e2e8f0);
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          margin-right: 8px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        
        .company-tabs .ant-tabs-tab.ant-tabs-tab-active {
          color: white;
        }
        
        
        .company-tabs .ant-tabs-nav {
          background: linear-gradient(135deg, #f1f5f9, #e2e8f0);
          padding: 16px;
          border-radius: 16px;
          margin-bottom: 24px;
        }
        
        .company-tabs .ant-tabs-content-holder {
          background: linear-gradient(135deg, #ffffff, #f8fafc);
          border-radius: 16px;
          border: 1px solid #e2e8f0;
        }
        
        .company-tabs .ant-tabs-tabpane {
          padding: 0;
        }
        
        /* Animation for tab switching */
        .company-tabs .ant-tabs-tabpane-active {
          animation: slideIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(20px) scale(0.15);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        
        /* 3D hover effect for content */
        .tab-content-3d {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          transform-style: preserve-3d;
        }
        
      `}</style>

      <Tabs
        activeKey={activeTab}
        items={items}
        onChange={handleTabChange}
        size="large"
        className="company-tabs"
        type="card"
        animated={{ tabPane: true }}
      />
    </div>
  );
};

export default CompanyTabs; 